import StyledNavbarLayout from './navbar/components/StyledNavbarLayout';
import { useOnlyAnswerDashboardLayout } from './navbar/hooks/useOnlyAnswerDashboardLayout';

export function OnlyAnswerDashboardLayout() {
  const { navConfig } = useOnlyAnswerDashboardLayout();
  return <StyledNavbarLayout navConfig={navConfig} />;
}
